import Vue from 'vue'
import Router from 'vue-router'
import {
    store
} from '../store'

// Containers
const TheContainer = () =>
    import('@/containers/TheContainer')

// Views
const Dashboard = () =>
    import('@/views/Dashboard')

// Views - Components
const CotizaAuto = () => import("@/views/autos/Cotiza")
const IngresaAuto = () => import("@/views/autos/Ingresa")
const ConfirmacionAuto = () => import("@/views/autos/Confirmacion")
const PanelAuto = () => import("@/views/autos/Panel")
const UsoAuto = () => import("@/views/autos/Uso")
const BeneficioAuto = () => import("@/views/autos/Beneficios")
const ValidateAuto = () => import("@/views/pages/Verify")
const AsistenciasAuto = () => import("@/views/autos/Asistencias")
const AccountAuto = () => import("@/views/autos/Account")
const AyudaAuto = () => import("@/views/autos/Ayuda")

const IndexWA = () => import('@/views/webApp/index')
const HomeWA = () => import("@/views/webApp/index")
const AccountWA = () => import("@/views/webApp/Account")
const HistoryWA = () => import("@/views/webApp/Autos")
const ErrorUrlAD = () => import("@/views/webApp/errorUrl")
// pantallas nuevas
const RespProsp = () => import("@/views/webApp/RespProsp")
const uploadList = () => import("@/views/webApp/uploadList")
const upL = () => import("@/views/webApp/UpListDocs")
const ErrorToken = () => import("@/views/webApp/ErrorToken")

//Innova 
const Innova = () => import("@/views/pagesLatino/innova")


// Infonavit
const ConsultaIFVT = () => import("@/views/infonavit/Consulta");
const FacturasIFVT = () => import('@/views/infonavit/Facturas');
const RegisterIFVT = () => import('@/views/infonavit/Register');

// Proveedores
const ConsultaPROV = () => import("@/views/proveedores/Consulta")
const OrdenCompraPROV = () => import("@/views/proveedores/OrdenDeCompra")
const CFDIsPROV = () => import("@/views/proveedores/CFDIs")
const LoginProveeodres = () => import('@/views/proveedores/Login')
const RegisterProveeodres = () => import('@/views/proveedores/Register')

//Clientes
const ConsultaClientes = () => import("@/views/clientes/Consulta")
const OrdenCompraClientes = () => import("@/views/clientes/OrdenDeCompra")
const CFDIsClientes = () => import("@/views/clientes/CFDIs")
const LoginClientes = () => import('@/views/clientes/Login')
const RegisterClientes = () => import('@/views/clientes/Register')
const ValidarClientes = () => import("@/views/clientes/Verify")
const ConsultaSolicitudes = () => import("@/views/clientes/Solicitudes")
const DelegadoCU = () => import("@/views/clientes/delegadoCU/ActualizarRF")


//sas
const Principal = () => import("@/views/sas/principal.vue")
const LoginSas = () => import("@/views/sas/loginProvee.vue")
const CargaArchivosSas = () => import("@/views/sas/masiva.vue")
const IndividualSas = () => import("@/views/sas/individual.vue")
const OperacionSas = () => import("@/views/sas/operacion.vue")
const ConsultaSas = () => import("@/views/sas/consulta.vue")
const UsuariosSas = () => import("@/views/sas/usuarios.vue")
const InicioSas = () => import("@/views/sas/inicio.vue")
const IndividualProveedorSas = () => import("@/views/sas/individualProvee.vue")

//SASP
const LoginSASP = () => import("@/views/sasp/loginSASP.vue")
const Solicitud = () => import("@/views/sasp/solicitud.vue")
const Consulta = () => import("@/views/sasp/consulta.vue")


//Pago en lina
const RegistroDom = () => import("@/views/pagoEnLinea/registroDomiciliacion.vue")

//Condiciones
const CondicionesGenerales = () => import("@/views/webApp/CondicionesGenerales.vue")

//Siniestros Valor Latino
const RenovacionValorLatino = () => import("@/views/renovacionValorLatino/renovacion.vue")
const PdfValorLatino = () => import("@/views/renovacionValorLatino/pdf.vue")

// Views - Notifications
const Alerts = () =>
    import('@/views/notifications/Alerts')
const Badges = () =>
    import('@/views/notifications/Badges')
const Modals = () =>
    import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () =>
    import('@/views/pages/Page404')
const Login = () =>
    import('@/views/pages/Login')
const Register = () =>
    import('@/views/pages/Register')
const LeadPer = () =>
    import('@/views/leads/LeadPer')

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: configRoutes()
})

router.beforeEach((to, from, next) => {
    const isRequireAuth = to.matched.some(item => item.meta.requireAuth)
    if (isRequireAuth && store.state.token === null) {
        next('/')
    } else {
        next()
    }
})

export default router

function configRoutes() {
    return [{
        path: '/',
        redirect: '/pages/login',
        name: 'Home',
        component: TheContainer,
        children: [
            {
                path: 'dashboard',
                name: 'Panel',
                component: Dashboard,
            },
            {
                path: '/auto/cotiza',
                name: 'Cotiza',
                component: CotizaAuto
            },
            {
                path: '/auto/ingresa',
                name: 'Ingresa',
                component: IngresaAuto
            },
            {
                path: '/auto/confirmacion',
                name: 'Ingresa',
                component: ConfirmacionAuto
            },
            {
                path: '/auto/panel',
                name: 'Ingresa',
                component: PanelAuto
            },
            {
                path: '/auto/uso',
                name: 'Uso de auto',
                component: UsoAuto
            },
            {
                path: '/auto/beneficios',
                name: 'Beneficios',
                component: BeneficioAuto
            },
            {
                path: 'asistencias',
                name: 'Asistencias',
                component: AsistenciasAuto
            },
            {
                path: 'account',
                name: 'Mi cuenta',
                component: AccountAuto
            },
            {
                path: 'ayuda',
                name: 'Ayuda',
                component: AyudaAuto
            },
            {
                path: 'infonavit',
                name: 'Infonavit',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [{
                    path: 'consulta',
                    name: 'Alerts',
                    component: ConsultaIFVT
                },
                {
                    path: 'facturas',
                    name: 'Facturas',
                    component: FacturasIFVT
                },
                ]
            },
            {
                path: 'proveedores',
                name: 'Proveedores',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [{
                    path: 'consulta',
                    name: 'Consulta de proveedores',
                    component: ConsultaPROV
                },
                {
                    path: 'ordenes-de-compra',
                    name: 'Órdenes de compra',
                    component: OrdenCompraPROV
                },
                {
                    path: 'cfdis',
                    name: 'CFDIs',
                    component: CFDIsPROV
                },
                {
                    path: 'login',
                    name: 'login',
                    component: LoginProveeodres
                },
                ]
            },
            {
                path: 'clientes',
                name: 'clientes',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [
                    {
                        path: 'consulta',
                        name: 'Consulta de clientes',
                        component: ConsultaClientes
                    },
                    {
                        path: 'solicitudes',
                        name: 'Consulta de solicitudes',
                        component: ConsultaSolicitudes
                    },
                    {
                        path: 'ordenes-de-compra',
                        name: 'Órdenes de compra',
                        component: OrdenCompraClientes
                    },
                    {
                        path: 'cfdis',
                        name: 'CFDIs',
                        component: CFDIsClientes
                    },
                    {
                        path: 'delegadoCU',
                        name: 'delegadoCU',
                        component: DelegadoCU
                    }
                ]
            },
            {
                path: 'notifications',
                redirect: '/notifications/alerts',
                name: 'Notifications',
                component: {
                    render(c) {
                        return c('router-view')
                    }
                },
                children: [{
                    path: 'alerts',
                    name: 'Alerts',
                    component: Alerts
                },
                {
                    path: 'badges',
                    name: 'Badges',
                    component: Badges
                },
                {
                    path: 'modals',
                    name: 'Modals',
                    component: Modals
                }
                ]
            }
        ]
    },
    {
        path: '/pages',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: '404',
            name: 'Page404',
            component: Page404
        },
        {
            path: 'login',
            name: 'Login',
            component: Login
        },
        {
            path: 'register',
            name: 'Register',
            component: Register
        },
        {
            path: 'infonavit/register',
            name: 'Register',
            component: RegisterIFVT
        },
        {
            path: 'verifiacion',
            name: 'Validación de cuenta',
            component: ValidateAuto
        },
        {
            path: 'leads',
            name: 'leads',
            component: LeadPer
        },
        // Web App
        {
            path: 'delegadoCU',
            name: 'delegadoCU',
            component: DelegadoCU
        },
        {
            path: 'app',
            name: 'Home',
            component: HomeWA,
        },
        {
            path: 'app/account',
            name: 'Account',
            component: AccountWA,
        },
        {
            path: 'app/history',
            name: 'History',
            component: HistoryWA,
        },
        {
            path: 'app/payment/error',
            name: 'error url',
            component: ErrorUrlAD,
        },
        {
            path: 'app/errorToken',
            name: 'error token',
            component: ErrorToken,
        },
        {
            path: 'app/respuestaProspecto/:token',
            name: 'Respuesta Prospecto',
            component: RespProsp,
        },
        {
            path: 'app/uploadList/:token',
            name: 'Subir Archivos',
            component: uploadList,
        },
        {
            path: 'app/CargarDocumentacion/:token',
            name: 'Subir Archivos 2',
            component: upL,
        },

        //pagesLatino
        {
            path: 'innova/altaConvenio/:idAgente/:poliza/:renov/:ramo',
            name: 'Alta Convenio',
            component: Innova,
        },
        // Pago en Linea
        {
            path: 'app/registro/:datos',
            name: 'Registro Domiciliacion',
            component: RegistroDom,
        },
        // Condiciones Generales
        {
            path: 'app/condiciones/:id',
            name: 'Condiciones generales',
            component: CondicionesGenerales,
        },
        ]
    },
    {
        path: '/clientes',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: '404',
            name: 'Page404',
            component: Page404
        },
        //clientes
        {
            path: 'login',
            name: 'login',
            component: LoginClientes
        },
        {
            path: 'register',
            name: 'Register',
            component: RegisterClientes
        },
        ]
    },
    {
        path: '/proveedores',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [{
            path: '404',
            name: 'Page404',
            component: Page404
        },
        //clientes
        {
            path: 'login',
            name: 'login',
            component: LoginClientes
        },
        ]
    },
    {
        path: '/sas',
        redirect: '/pages/404',
        name: 'Pages',
        component: Principal,
        children: [
            {
                path: 'inicio',
                name: 'Inicio',
                component: InicioSas,
            },
            {
                path: 'cargaArchivo',
                name: 'Cargar archivos',
                component: CargaArchivosSas,
            },
            {
                path: 'individual',
                name: 'Individual',
                component: IndividualSas,
            },
            {
                path: 'operacion',
                name: 'Operacion',
                component: OperacionSas,
            },
            {
                path: 'consulta',
                name: 'Consulta',
                component: ConsultaSas,
            },
            {
                path: 'individualPr',
                name: 'individual Proveedor',
                component: IndividualProveedorSas,
            }
            ,
            {
                path: 'altaUsuarios',
                name: 'Usuarios',
                component: UsuariosSas,
            }
        ]
    },
    {
        path: '/sas/login',
        // name: 'Login proveedores',
        component: LoginSas,
    },
    {
        path: '/sasp',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: 'login',
                name: 'Login SASP',
                component: LoginSASP,
            },
            {
                path: 'solicitud',
                name: 'Solicitud',
                component: Solicitud,
            },
            {
                path: 'consulta',
                name: 'Consulta',
                component: Consulta,
            },
        ]
    },
    {
        path: '/sasp',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: 'login',
                name: 'Login SASP',
                component: LoginSASP,
            },
            {
                path: 'solicitud',
                name: 'Solicitud',
                component: Solicitud,
            },
            {
                path: 'consulta',
                name: 'Consulta',
                component: Consulta,
            },
        ]
    },
    {
        path: '/valor-latino',
        redirect: '/pages/404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: 'renovacion',
                name: 'Renovacion Valor Latino',
                component: RenovacionValorLatino,
            },
            {
                path: 'documento',
                name: 'Pdf',
                component: PdfValorLatino
            }
        ]
    }
    ]
}